import { formatAmount, formatDate } from '@/lib/venue/format'
import type { VenueRevenueDashboardView } from '@/lib/venue/revenueTypes'

/**
 * 대시보드 "이번 달 매출 요약" — `/revenues/dashboard`의 `monthly`(예약액·취소환불·수수료) +
 * `settlement`(정산 확정 금액·다음 지급 예정) 5지표(이슈 요구사항 4).
 *
 * 🚨 두 블록을 더하거나 비교하지 않는다(api-spec §3 "두 블록의 축이 다르다") — 그냥 5칸을 나란히
 * 그릴 뿐, 값을 합산하는 코드를 이 컴포넌트에 두지 않는다.
 */
export function DashboardRevenueSummary({ data }: { data: VenueRevenueDashboardView }) {
  return (
    <dl className="grid grid-cols-2 gap-4 sm:grid-cols-5">
      <div>
        <dt className="text-xs text-slateish-600">예약액</dt>
        <dd className="mt-1 text-base font-semibold text-ink-700">
          {formatAmount(data.monthly.reservationAmount)}
        </dd>
      </div>
      <div>
        <dt className="text-xs text-slateish-600">취소·환불</dt>
        <dd className="mt-1 text-base font-semibold text-danger-500">
          -{formatAmount(data.monthly.refundedAmount)}
        </dd>
      </div>
      <div>
        <dt className="text-xs text-slateish-600">수수료</dt>
        <dd className="mt-1 text-base font-semibold text-ink-700">
          -{formatAmount(data.monthly.appliedFeeAmount)}
        </dd>
      </div>
      <div>
        <dt className="text-xs text-slateish-600">
          정산 확정 금액{data.settlement.confirmed ? '' : ' (예정)'}
        </dt>
        <dd className="mt-1 text-base font-semibold text-ink-700">
          {formatAmount(data.settlement.confirmedAmount)}
        </dd>
      </div>
      <div>
        <dt className="text-xs text-slateish-600">다음 지급 예정</dt>
        <dd className="mt-1 text-base font-semibold text-ink-700">
          {formatAmount(data.settlement.nextEstimatedPayoutAmount)}
        </dd>
        <p className="mt-0.5 text-xs text-slateish-400">{formatDate(data.settlement.nextPayoutDate)} 지급</p>
      </div>
    </dl>
  )
}
